import { useNavigate } from 'react-router-dom';

const HomePage = () => {
  const navigate = useNavigate();

  // Handle logout
  const handleLogout = () => {
    // Remove the token from localStorage
    localStorage.removeItem('accessToken');

    // Redirect to login page
    navigate('/');
  };

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1>Chess Tournament Manager</h1>
      <button
        style={{ margin: '10px', padding: '10px 20px' }}
        onClick={() => navigate('/create-tournament')}
      >
        Create Tournament
      </button>
      <button
        style={{ margin: '10px', padding: '10px 20px' }}
        onClick={() => navigate('/fetch-tournaments')}
      >
        Fetch Tournaments
      </button>
      <button
        style={{ margin: '10px', padding: '10px 20px' }}
        onClick={() => navigate('/withdraw-request')}
      >
        Withdrawal Request
      </button>
      <button
        style={{ margin: '10px', padding: '10px 20px' }}
        onClick={() => navigate('/user-wallet')}
      >
        User Wallet
      </button>

      {/* Logout Button */}
      <button
        style={{ margin: '10px', padding: '10px 20px', backgroundColor: 'red', color: 'white' }}
        onClick={handleLogout}
      >
        Logout
      </button>

      <div style={{ margin: '0', padding: '0', height: '75vh', width: '100%', overflow: 'hidden' }}>
        <img
          src='https://images.unsplash.com/photo-1523875194681-bedd468c58bf?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fGNoZXNzfGVufDB8fDB8fHww'
          alt="Chess"
          style={{
            height: '100%',
            width: '100%',
            objectFit: 'cover',
            display: 'block'
          }}
        />
      </div>
    </div>

  );
};

export default HomePage;
